export default "<app-nav-bar></app-nav-bar>\n<main class=\"container main-section navbar-padding\">\n  <router-outlet></router-outlet>\n</main>\n\n";